import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Download = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("polygon", { points: "17.791,9.258 12.791,14.258 12.791,1.984 10.791,1.984 10.791,14.258 5.791,9.258 4.377,10.672 11.791,18.086 19.205,10.672 " }),
    React.createElement("rect", { x: "2.041", y: "20.016", width: "19.918", height: "2" })), 'Download');
export default Download;
